import { render, staticRenderFns } from "./AcademicYear.vue?vue&type=template&id=6693d855&"
import script from "./AcademicYear.vue?vue&type=script&lang=js&"
export * from "./AcademicYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports